module.exports = __webpack_public_path__ + "img/icon-card.5abaf966.svg";